import { useState, useEffect } from "react"

import { AccountId } from "query/graphql"

type ProposalIdExceptions = {
  [governanceId: AccountId]: {
    previousProposalsCount: number
  }
}

const PROPOSALS_ID_EXCEPTIONS: ProposalIdExceptions = {
  uniswap: {
    previousProposalsCount: 5,
  },
  cryptex: {
    previousProposalsCount: 3,
  },
}

const GOVERNANCES_WITH_PROPOSAL_IDS_EXCEPTIONS = Object.keys(
  PROPOSALS_ID_EXCEPTIONS,
) as AccountId[]

type Values = {
  proposalId: string
}

type Props = {
  proposalId: string
  governanceId: AccountId
}

export const useNormalizeProposalId = ({
  proposalId: proposalIdProp,
  governanceId,
}: Props): Values => {
  const [proposalId, setProposalId] = useState<string>(proposalIdProp)

  const isGovernanceWithIdException =
    GOVERNANCES_WITH_PROPOSAL_IDS_EXCEPTIONS.includes(governanceId)

  useEffect(() => {
    if (!proposalIdProp) {
      return
    }

    const shouldUpdateProposalId =
      isGovernanceWithIdException &&
      Number(proposalId) >
        Number(PROPOSALS_ID_EXCEPTIONS[governanceId].previousProposalsCount)

    if (shouldUpdateProposalId) {
      const proposalIdUpdated =
        Number(proposalId) -
        Number(PROPOSALS_ID_EXCEPTIONS[governanceId].previousProposalsCount)

      setProposalId(proposalIdUpdated.toString())
    }
  }, [proposalId, governanceId])

  return { proposalId }
}
